
import { isNoneNull } from '../../utils/isNoneNull'
import { IIntakeStep } from './IIntakeStep'
import { IntakeStepChecklist } from './IntakeStepChecklist'
import { IntakeStepInputSurgeryType } from './IntakeStepInputSurgeryType/index'

const intake2StepsEnglish: IIntakeStep[] = [
  {
    Component: IntakeStepInputSurgeryType, completed: intake => !!intake.surgeryType,
    label: 'We’re now going to ask you for some more detailed information about your child’s surgery.',
    name: 'surgeryType',
  },
  {
    Component: IntakeStepChecklist, completed: intake => isNoneNull(
      intake.surgeryOptionsBeWithChild,
      intake.surgeryOptionsReceiveSedative,
      intake.surgeryOptionsNeither,
    ) ,
    description: '1. You may be permitted to accompany your child while they go to sleep.\n\n' +
      '2. Your child may be given a sedative before surgery.\n\n' +
      // tslint:disable-next-line
      'If you would like to employ one of the above techniques, indicate your preference below. Please keep in mind that the final decision will rest with the anesthesiologist and other healthcare professionals.',
      // tslint:disable-next-line
    label: `Some parents may be concerned about their child's anxiety during surgery. There are some options below for you to consider on the day of surgery:`,
    options: [
      { label: 'I would like to be with my child while they go to sleep.', name: 'surgeryOptionsBeWithChild' },
      { label: 'I would like my child to receive a sedative before they go to sleep.',
        name: 'surgeryOptionsReceiveSedative' },
      { label: `I do not want either option listed above and would like the nurse and anesthesiologist to stay with
        my child as they go to sleep.`, name: 'surgeryOptionsNeither' },
    ],
  },
]


const intake2StepsSpanish: IIntakeStep[] = [
  {
    Component: IntakeStepInputSurgeryType, completed: intake => !!intake.surgeryType,
    label: 'Ahora vamos a pedirle más información sobre la cirugía de su hijo.',
    name: 'surgeryType',
  },
  {
    Component: IntakeStepChecklist, completed: intake => isNoneNull(
      intake.surgeryOptionsBeWithChild,
      intake.surgeryOptionsReceiveSedative,
      intake.surgeryOptionsNeither,
    ) ,
    description: '1. Es posible que permitan que este con su hijo mientras se duerme.\n\n' +
      '2. Su hijo puede recibir un sedante antes de la cirugía.\n\n' +
      // tslint:disable-next-line
      'Si desea utilizar una de las opciones anteriores, elija una de las siguientes. Tenga en cuenta que el anestesiólogo y el personal médico tomarán la decisión final.',
    // tslint:disable-next-line
    label: ` Algunos padres pueden estar preocupados por la ansiedad de su hijo durante la cirugía. A continuación le ofrecemos algunas opciones para que las tenga en cuenta el día de la cirugía.`,
    options: [
      { label: 'Me gustaría estar con mi hijo mientras se duerme.', name: 'surgeryOptionsBeWithChild' },
      { label: 'Me gustaría que mi hijo recibiera un sedante antes de dormirse.',
        name: 'surgeryOptionsReceiveSedative' },
      { label: `No quiero ninguna de las dos opciones mencionadas anteriormente. Deseo que el personal médico se quede con mi hijo cuando se vaya a dormir.`, name: 'surgeryOptionsNeither' },
    ],
  },
]

export const intake2Steps = process.env.REACT_APP_LANGUAGE === 'es' ? intake2StepsSpanish : intake2StepsEnglish



// WEBPACK FOOTER //
// ./src/organisms/Intakes/intake2Steps.tsx